import KnownMeasureDetailPage from './KnownMeasureDetailPage';

export default KnownMeasureDetailPage;